import React, { useCallback, useEffect, useMemo } from 'react';
import Mousetrap from 'mousetrap';
import { BreakpointContext } from '@core/components/Layout/Breakpoint/BreakpointContext';
import { useMeasure } from '@core/hooks/useMeasure';
import { uuidv4 } from '@embed/helpers';
import { Backdrop } from './Backdrop';
import { ModalContext } from './ModalContext';
import { ModalFocusTrap } from './ModalFocusTrap';
/**
 * Modal.Wrapper component for common/Modal serves as a basic building block
 * for modals.
 */
export const Wrapper = ({ children, ...props }) => {
    const { className, backdropCss, onBackdropClick = () => null } = props;
    const onBackdropClickHandler = useCallback((event) => {
        event.stopPropagation();
        event.preventDefault();
        onBackdropClick(event);
    }, [onBackdropClick]);
    useEffect(() => {
        onBackdropClick && Mousetrap.bind(['esc'], onBackdropClick);
        return () => Mousetrap.unbind(['esc'], onBackdropClick);
    }, [onBackdropClick]);
    const contextValue = useMemo(() => {
        return {
            ...props,
            // branding is true by default. When it is not set on props, we will pass
            // true to the context.
            branding: props.branding ?? true,
            // TODO (CS-6408) explore using modal key in the store for this
            titleId: uuidv4(),
        };
    }, [props]);
    const { ref, rect: { height, width }, } = useMeasure();
    return (<ModalContext.Provider value={contextValue}>
      <ModalFocusTrap>
        <Backdrop onClick={onBackdropClickHandler} backdropCss={backdropCss}>
          <BreakpointContext.Provider value={{
            height: height ?? 0,
            width: width ?? 0,
            provider: 'Inner Modal',
        }}>
            <div ref={ref} className={className}>
              {children}
            </div>
          </BreakpointContext.Provider>
        </Backdrop>
      </ModalFocusTrap>
    </ModalContext.Provider>);
};
